import { RefObject, useEffect, useState } from 'react';

import { DocumentationHeading } from 'api/documentation';

import { tocHeadings } from '../DocumentationToc';

import { findInPanel } from './utils';

/** Room below the panel header before a heading counts as the current one. */
const ACTIVE_MARGIN = 24;

/**
 * The section being read in the panel: the last heading scrolled to the top
 * of the panel's own scroll area (the panel scrolls apart from the app).
 */
export const usePanelSection = (
  container: RefObject<HTMLElement>,
  headings: DocumentationHeading[],
) => {
  const [activeId, setActiveId] = useState<string>();

  useEffect(() => {
    const element = container.current;
    if (!element) return;
    const items = tocHeadings(headings);
    const update = () => {
      const top = element.getBoundingClientRect().top + ACTIVE_MARGIN;
      let current: string | undefined;
      items.forEach(({ id }) => {
        const heading = findInPanel(element, id);
        if (heading && heading.getBoundingClientRect().top <= top) current = id;
      });
      setActiveId(current);
    };
    update();
    element.addEventListener('scroll', update, { passive: true });
    return () => element.removeEventListener('scroll', update);
  }, [container, headings]);

  return activeId;
};
